import { Navigate } from 'react-router-dom'
import { SignIn } from '@clerk/clerk-react'
import { ChefHat } from 'lucide-react'
import { useAppAuth } from '@/auth/AuthProvider'

export function SignInPage() {
  const { clerkEnabled, isAuthenticated } = useAppAuth()
  if (!clerkEnabled) return <Navigate to="/" replace />
  if (isAuthenticated) return <Navigate to="/" replace />
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-6 p-6">
      <div className="flex items-center gap-2 text-xl font-bold text-gray-900">
        <ChefHat className="h-6 w-6 text-orange-500" />
        <span>Food Image Transformer</span>
      </div>
      <SignIn routing="path" path="/sign-in" forceRedirectUrl="/" />
    </div>
  )
}
